module.exports = __webpack_public_path__ + "static/img/15045A_1_R_20221017_LC.622c3fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15045A_1_R_20221017_LC.png
// module id = KoIK
// module chunks = 0